import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { getAllGiftProducts, deleteGiftProduct } from '../../shared/api/user';
import { useState, useEffect } from 'react';
import "./gifts.css";
import { useNavigate } from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions  from '@mui/material/DialogActions';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { CITY_NAMES } from '../../shared/constants/cities';

export default function ImgMediaCard() {
    const navigate = useNavigate();
    const [gifts, setGifts] = useState([]);
    const [selectedCity, setSelectedCity] = useState('ALL');
    
    const [openModal, setOpenModal] = useState(false);
    const [zeroRateItems, setZeroRateItems] = useState([]);
const checkZeroRateItems = () => {
  const zeroItems = gifts.filter(gift => {
    return (
      gift.priceOMR === 0 ||
      gift.priceQAR === 0 ||
      gift.priceKWD === 0 ||
      gift.priceBHD === 0 ||
      gift.priceUSD === 0 ||
      gift.priceCAD === 0 ||
      gift.priceAED === 0 ||
      gift.priceAUD === 0 ||
      gift.priceGBP === 0 ||
      gift.priceSAR === 0 
    );
  });
  
  if (zeroItems.length > 0) {
    setZeroRateItems(zeroItems);
    setOpenModal(true);
  }
};


    const init = async () => {
      let rows = await getAllGiftProducts(0, 400);
        setGifts(rows.data.Gifts);
    }

    useEffect(() => {
        init();
    }, []);

    const deleteProduct = async (id) =>{
        await deleteGiftProduct(id);
        init();
      }

    const normalize = (value) => String(value || '').trim().toLowerCase();
    const giftHasCity = (gift) => {
      const giftCities = Array.isArray(gift.city)
        ? gift.city
        : String(gift.city || '').split(',').map((city) => city.trim()).filter(Boolean);

      return giftCities.some((city) => normalize(city) === normalize(selectedCity));
    };
    const filteredGifts = selectedCity === 'ALL'
      ? gifts
      : gifts.filter(giftHasCity);

    return (
        <>
        
         <Button 
            onClick={checkZeroRateItems} 
            variant="outlined" 
            color="warning" 
            sx={{ mr: 2 }}
            >
            Check Zero Rate Items
            </Button>

            <Dialog 
  open={openModal} 
  onClose={() => setOpenModal(false)}
  maxWidth="md"
  fullWidth
>
  <DialogTitle>
    Zero Rate Items
    <Typography variant="subtitle2" color="error">
      The following items have zero rates in one or more currencies
    </Typography>
  </DialogTitle>
  <DialogContent>
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Product Name</TableCell>
            <TableCell align="right">USD</TableCell>
            <TableCell align="right">CAD</TableCell>
            <TableCell align="right">AED</TableCell>
            <TableCell align="right">AUD</TableCell>
            <TableCell align="right">GBP</TableCell>
            <TableCell align="right">SAR</TableCell>

            <TableCell align="right">OMR</TableCell>
            <TableCell align="right">QAR</TableCell>
            <TableCell align="right">KWD</TableCell>
            <TableCell align="right">BHD</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {zeroRateItems.map((item) => (
            <TableRow key={item._id}>
              <TableCell component="th" scope="row">
                {item.name}
              </TableCell>

              <TableCell align="right" sx={{ 
                color: item.priceUSD === 0 ? 'error.main' : 'inherit',
                fontWeight: item.priceUSD === 0 ? 'bold' : 'normal'
              }}>
                {item.priceUSD}
              </TableCell>

              <TableCell align="right" sx={{ 
                color: item.priceCAD === 0 ? 'error.main' : 'inherit',
                fontWeight: item.priceCAD === 0 ? 'bold' : 'normal'
              }}>
                {item.priceCAD}
              </TableCell>

                            <TableCell align="right" sx={{ 
                color: item.priceAED === 0 ? 'error.main' : 'inherit',
                fontWeight: item.priceAED === 0 ? 'bold' : 'normal'
              }}>
                {item.priceAED}
              </TableCell>

              <TableCell align="right" sx={{ 
                color: item.priceAUD === 0 ? 'error.main' : 'inherit',
                fontWeight: item.priceAUD === 0 ? 'bold' : 'normal'
              }}>
                {item.priceAUD}
              </TableCell>

                            <TableCell align="right" sx={{ 
                color: item.priceGBP === 0 ? 'error.main' : 'inherit',
                fontWeight: item.priceGBP === 0 ? 'bold' : 'normal'
              }}>
                {item.priceGBP}
              </TableCell>





              <TableCell align="right" sx={{ 
                color: item.priceSAR === 0 ? 'error.main' : 'inherit',
                fontWeight: item.priceSAR === 0 ? 'bold' : 'normal'
              }}>
                {item.priceSAR}
              </TableCell>
              
              <TableCell align="right" sx={{ 
                color: item.priceOMR === 0 ? 'error.main' : 'inherit',
                fontWeight: item.priceOMR === 0 ? 'bold' : 'normal'
              }}>
                {item.priceOMR}
              </TableCell>
              
              <TableCell align="right" sx={{ 
                color: item.priceQAR === 0 ? 'error.main' : 'inherit',
                fontWeight: item.priceQAR === 0 ? 'bold' : 'normal'
              }}>
                {item.priceQAR}
              </TableCell>
              <TableCell align="right" sx={{ 
                color: item.priceKWD === 0 ? 'error.main' : 'inherit',
                fontWeight: item.priceKWD === 0 ? 'bold' : 'normal'
              }}>
                {item.priceKWD}
              </TableCell>
              <TableCell align="right" sx={{ 
                color: item.priceBHD === 0 ? 'error.main' : 'inherit',
                fontWeight: item.priceBHD === 0 ? 'bold' : 'normal'
              }}>
                {item.priceBHD}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setOpenModal(false)}>Close</Button>
  </DialogActions>
</Dialog>

            <Button onClick={() => window.location.href = '/add/product'} variant="outlined" startIcon={<AddIcon />}>
                Add Product
            </Button>
            <label htmlFor="gift-city-filter" style={{ margin: '0 8px 0 16px', fontWeight: 500 }}>City:</label>
            <select
                id="gift-city-filter"
                value={selectedCity}
                onChange={(event) => setSelectedCity(event.target.value)}
                style={{ padding: '7px 10px', minWidth: 180 }}
            >
                <option value="ALL">All cities</option>
                {CITY_NAMES.map((city) => (
                    <option key={city} value={city}>{city.replace(/\b\w/g, (letter) => letter.toUpperCase())}</option>
                ))}
            </select>
            <div className='cards-p'>
                {filteredGifts?.map((row) => (
                    <Card key={row._id} className='card-c' sx={{ maxWidth: 345 }}>
                        <CardMedia
                            component="img"
                            alt="gift-image"
                            height="220"
                            image={row.picture}
                             sx={{ 
                                objectFit: 'contain',  
                                backgroundColor: '#f5f5f5' // This shows the top part of the image instead of center
                            }}
                                                />
                        <CardContent>
                            <Typography gutterBottom variant="h5" component="div">
                                {row.name}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {row.description}
                            </Typography>
                            <Typography gutterBottom component="div">
                            Rs. {row.price}
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Button size="small" onClick={() => window.location.href = `/edit/product/${row._id}`}>Edit</Button>
                            <Button  onClick={() => deleteProduct(row._id)} size="small">Delete</Button>
                        </CardActions>
                    </Card>
                ))}
            </div>
        </>
    );
}
